export const pageViews = () => {
  window.addEventListener('single-spa:before-routing-event', evt => {
    const url = new URL(evt.detail.newUrl)

    window.gtag?.('event', 'page_view', {
      page_path: url.pathname,
      page_url: url.href,
    })
  })
}
